import { combineReducers } from 'redux';
import {
  SET_BUTTON_ELEMENT_TEXT,
  SET_BUTTON_ELEMENT_URL,
  SET_BUTTON_ELEMENT_TARGET,
  SET_BUTTON_ELEMENT_CORNER_RADIUS,
  SET_BUTTON_ELEMENT_WIDTH,
  SET_BUTTON_ELEMENT_PADDING,
} from '../actions/action-names';

const text = (state = '', action) => {
  switch (action.type) {
    case SET_BUTTON_ELEMENT_TEXT:
      return action.value;
    default:
      return state;
  }
};

const url = (state = '', action) => {
  switch (action.type) {
    case SET_BUTTON_ELEMENT_URL:
      return action.value;
    default:
      return state;
  }
};

const target = (state = '', action) => {
  switch (action.type) {
    case SET_BUTTON_ELEMENT_TARGET:
      return action.value;
    default:
      return state;
  }
};

const cornerRadius = (state = '', action) => {
  switch (action.type) {
    case SET_BUTTON_ELEMENT_CORNER_RADIUS:
      return action.value;
    default:
      return state;
  }
};

const width = (state = '', action) => {
  switch (action.type) {
    case SET_BUTTON_ELEMENT_WIDTH:
      return action.value;
    default:
      return state;
  }
};

const padding = (state = '', action) => {
  switch (action.type) {
    case SET_BUTTON_ELEMENT_PADDING:
      return action.value;
    default:
      return state;
  }
};

export default combineReducers({
  text,
  url,
  target,
  cornerRadius,
  width,
  padding,
});



// WEBPACK FOOTER //
// ./app/header-builder/reducers/button-element-options-reducers.js